import { useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { VehicleCard } from './VehicleCard';
import { PrimaryButton } from '../../components/button/PrimaryButton';
import { Spinner } from '../../components/Spinner';
import { useInfiniteFetchVehicles } from '../../hooks/useFetchVehicles';
import { t } from '../../services/translation/translation';

export const VehiclesCards = () => {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const orderBy = searchParams.get('orderBy') ?? 'resume.departureAt';
  const direction = (searchParams.get('direction') ?? 'desc') as 'desc' | 'asc';

  const { data, isLoading, hasNextPage, isFetchingNextPage, fetchNextPage } = useInfiniteFetchVehicles({
    direction,
    orderBy,
  });

  const vehicles = useMemo(() => data?.pages.map(p => p.items).flat() || [], [data]);

  return (
    <div>
      <div className="p-5 text-lg font-semibold text-left text-gray-900 bg-white dark:text-white dark:bg-gray-800">
        <div className="flex gap-2 items-start">
          <div className="flex-1">
            {t('vehicles-route.table-title')}
            <p className="mt-1 text-sm font-normal text-gray-500 dark:text-gray-400">{t('vehicles-route.caption')}</p>
          </div>
          <PrimaryButton text={t('common.add')} onClick={() => navigate('add')} />
        </div>
      </div>
      <div className="mt-3">
        <div className="space-y-2">
          {vehicles.map(vehicles => (
            <VehicleCard key={vehicles.id} vehicle={vehicles} />
          ))}
        </div>

        <div>
          {hasNextPage ? (
            <div className="flex justify-center mt-3">
              <PrimaryButton
                onClick={() => {
                  fetchNextPage();
                }}
                isLoading={isFetchingNextPage}
              >
                {t('common.see-more')}
              </PrimaryButton>
            </div>
          ) : null}
          <div>{isLoading ? <Spinner /> : null}</div>
        </div>
      </div>
    </div>
  );
};
